import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { Validators } from '@angular/forms';
import { ContributorTypeEnum } from 'src/app/domain/registration/enums/contributor-type.enum';
import { LegalPersonalityEnum } from 'src/app/domain/enums/legal-personality.enum';
import { PlanIndexSelectComponent } from '../../plans/crud-index/crud-index-select.component';
import { PlanSelectionWizardComponent } from '../../plans/plan-selection-wizard/plan-selection-wizard.component';
import { RegimeTypeEnum } from 'src/app/domain/registration/enums/regime-type.enum';

/**
 * Definição dos campos do formulário para o briefing de Cadastro de Cliente.
 */
export const REGISTER_PARTNERS_CONFIG: IFieldConfig[] = [
     

     //Tipo de CPF ou CNPJ
    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'TIPO',
        name: 'legalPersonality',
        value: LegalPersonalityEnum.PESSOA_FISICA,
        options: Object.values(LegalPersonalityEnum),
    },
    //Nome do Cliente 
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Nome ', 
        name: 'name',
        placeholder: 'Digite seu Nome ',
        validation: [Validators.required, Validators.minLength(4)],
      
    },
    //CPF
    {
        type: TypeComponentFieldEnum.INPUT_CPF,
        label: 'CPF', 
        name: 'cpf',
        placeholder: 'Digite seu CPF',
        validation: [Validators.minLength(11)],
      
    },
     //CNPJ
    {
        type: TypeComponentFieldEnum.INPUT_CNPJ,
        label: 'CNPJ', 
        name: 'cnpj',
        placeholder: 'Digite seu Cnpj',
        validation: [Validators.minLength(14)],
      
    },
    // rg - input
    {
        label: 'RG',
        name: 'generalRegistration',
        type: TypeComponentFieldEnum.INPUT_NUMBER,
        validation: [Validators.pattern(/\d+/)],
    },
      // ie - input
    {
        label: 'IE',
        name: 'stateRegistration',
        type: TypeComponentFieldEnum.INPUT_NUMBER,
    },
    //Data de Nascimento
    {
        label: 'DATA DE NASCIMENTO',
        name: 'birthday',
        type: TypeComponentFieldEnum.INPUT_DATE,
        validation: [],
    },
    {
        label: 'RAZÃO SOCIAL',
        name: 'companyName',
        type: TypeComponentFieldEnum.INPUT,
        validation: [Validators.minLength(4)],
    },
    // fantasia - input
    {
        label: 'FANTASIA',
        name: 'tradingName',
        type: TypeComponentFieldEnum.INPUT,
        validation: [Validators.required, Validators.minLength(4)],
    },

    // incr. municipal - number
    {
        label: 'INCR. MUNICIPAL',
        name: 'municipalRegistration',
        type: TypeComponentFieldEnum.INPUT_NUMBER,
    },
     // regime - select
    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'TIPO CONTRIBUINTE',
        name: 'contributorType',
        value: ContributorTypeEnum.CONTRIBUTOR,
        options: Object.values(ContributorTypeEnum),
        placeholder: 'Selecione uma opção',
        validation: [Validators.required],
    },
    // celular - input phone
    {
        label: 'CELULAR',
        name: 'cellPhone',
        type: TypeComponentFieldEnum.INPUT_CELLPHONE,
        validation: [Validators.required, Validators.minLength(11)],
    },
    // telefone - input phone
    {
        label: 'TELEFONE',
        name: 'phone',
        type: TypeComponentFieldEnum.INPUT_PHONE,
    },
    {
        label: 'EMAIL',
        name: 'email',
        type: TypeComponentFieldEnum.INPUT_EMAIL,
        validation: [Validators.required, Validators.minLength(14)],
    },
    // web site - input
    {
        label: 'WEB SITE',
        name: 'webSite',
        type: TypeComponentFieldEnum.INPUT,
    },
      // regime - select
    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'REGIME',
        name: 'regime',
        options: Object.values(RegimeTypeEnum),
        value: RegimeTypeEnum.SIMPLE,
        placeholder: 'Selecione uma opção',
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT_CEP,
        label: 'CEP',
        name: 'cep',
        placeholder: 'Insira o CEP',
        validation: [Validators.required, Validators.minLength(7)],
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'UF',
        name: 'state',
        placeholder: 'Digite a UF do estado',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'CIDADE',
        name: 'city',
        placeholder: 'Digite o nome da cidade',
        validation: [],
    },
        {
        type: TypeComponentFieldEnum.INPUT,
        label: 'ENDEREÇO',
        name: 'address',
        placeholder: 'Insira o endereço',
        validation: [Validators.required, Validators.minLength(4)],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'COMPLEMENTO',
        name: 'addressComplement',
        placeholder: 'Insira o complemento se houver',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT_NUMBER,
        label: 'Nº',
        name: 'addressNumber',
        placeholder: 'Insira o número caso houver',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'BAIRRO',
        name: 'neighborhood',
        placeholder: 'Insira o bairro',
        validation: [Validators.required, Validators.minLength(4)],
    },


    
    //Configurações e Login 
     // contato suporte - input

    // campos de corte e repasse
    {
        label: 'Dia de Corte',
        name: 'cutoffDay',
        type: TypeComponentFieldEnum.INPUT_NUMBER,
        validation: [Validators.required, Validators.min(1), Validators.max(31)],
    },
    {
        label: 'Dia de Repasse',
        name: 'transferDay',
        type: TypeComponentFieldEnum.INPUT_NUMBER,
        validation: [Validators.required, Validators.min(1), Validators.max(31)],
    },
    {
        label: 'WEB SITE / LINK',
        name: 'webSiteLink',
        type: TypeComponentFieldEnum.INPUT,
    },
    {
        label: 'CONTATO SUPORTE',
        name: 'supportContact',
        type: TypeComponentFieldEnum.INPUT_PHONE,
    },
      // comentário - input
    {
        label: 'COMENTÁRIO',
        name: 'comment',
        type: TypeComponentFieldEnum.INPUT,
    },



    //TIPOS E COMISSÕES
    {
        type: TypeComponentFieldEnum.INPUT_PERCENT,
        label: 'COMISSÃO DO CONSULTOR',
        name: 'consultantCommission',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT_PERCENT,
        label: 'COMISSÃO DO PARCEIRO',
        name: 'partnerCommission',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT_PERCENT,
        label: 'COMISSÃO DO REPRESENTANTE',
        name: 'representativeCommission',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT_PERCENT,
        label: 'COMISSÃO DO CONTADOR',
        name: 'counterCommission',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT_PERCENT,
        label: 'COMISSÃO DA UNIDADE',
        name: 'unitCommission',
        validation: [],
    },
    // IS CONSULTANT
    {
        type: TypeComponentFieldEnum.SLIDE_TOGGLE,
        label: 'É CONSULTOR',
        name: 'isConsultant',
    },
    // IS PARTNER
    {
        type: TypeComponentFieldEnum.SLIDE_TOGGLE,
        label: 'É PARCEIRO',
        name: 'isPartner',
    },
    // IS REPRESENTATIVE
    {
        type: TypeComponentFieldEnum.SLIDE_TOGGLE,
        label: 'É REPRESENTANTE',
        name: 'isRepresentative',
    },
    // IS COUNTER
    {
        type: TypeComponentFieldEnum.SLIDE_TOGGLE,
        label: 'É CONTADOR',
        name: 'isCounter',
    },
    // IS UNIT
    {
        type: TypeComponentFieldEnum.SLIDE_TOGGLE,
        label: 'É UNIDADE',
        name: 'isUnit',
    },
    {
        type: TypeComponentFieldEnum.SLIDE_TOGGLE,
        label: 'É FORNECEDOR',
        name: 'isSupplier',
    },
    {
        type: TypeComponentFieldEnum.SLIDE_TOGGLE,
        label: 'REVENDA',
        name: 'isResale',
    },
    {
        type: TypeComponentFieldEnum.HIDDEN,
        label: 'Flag de registro',
        name: 'registered',
        defaultValue: false,
    },


];
